module.exports = __webpack_public_path__ + "static/media/unscrupulous-recipients.056e605f.pdf";